import React from 'react';

// Styles & Assets
import styles from './Backdrop.module.css';

// Backdrop: Component that allows to show a modal with the app
// on background. Receives props:
//  -show: boolean that indicates if the backdrop has to be visible.
//  -clicked: function that closes the backdrop if we pass true as a parameter.
const Backdrop: React.FC<{
    show: boolean,
    clicked: (close: boolean) => void,
    classesBackdrop?: string,
    secondModal?: boolean,
}> = ({ show, clicked, classesBackdrop, secondModal }) => {

    const handleClick = () => clicked(true);

    const classes = `${styles.Backdrop} ${show ? styles.showBackdrop : ''} 
        ${classesBackdrop !== undefined ? classesBackdrop : ''}`;

    return (
        <div
            role='button'
            className={classes}
            style={{ zIndex: secondModal ? 1100 : 1000 }}
            onClick={handleClick}>
        </div>
    );
};

export default Backdrop;